import * as tslib_1 from "tslib";
import * as React from 'react';
import classnames from 'classnames';
import axios from 'axios';
import get from 'lodash.get';
import { DealerStaticViewer } from '@wix/react-dealer-viewer';
import ErrorBoundary from '../ErrorBoundary';
import SwipeSlider from '../SwipeSlider';
import CloseIconBold from '../Icons/CloseBold';
import ButtonB5 from '../Button/ButtonB5';
import BiLogger, { BiEventType } from '../biLogger';
import { IconSize } from '../Icons/IconWrap';
import s from './DealerAd.scss';
var DealerAd = /** @class */ (function (_super) {
    tslib_1.__extends(DealerAd, _super);
    function DealerAd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loaded: false,
            banners: [],
            isEmpty: false,
        };
        _this.renderBanner = function (banner) {
            var _a = _this.props, withCloseButton = _a.withCloseButton, userGuid = _a.userGuid, biClientId = _a.biClientId, realEstateId = _a.realEstateId, additionalParams = _a.additionalParams;
            return (React.createElement("div", { key: banner.bannerId, className: s['banner-wrapper'] },
                React.createElement(DealerStaticViewer, { dealerOptions: additionalParams, bannerPosition: _this.props.realEstateId, locale: "en", metasiteGuid: "", translationsUrl: "https://static.parastorage.com/services/dealer-cms-translations/1.860.0/", banner: banner, additionalBiParams: {
                        _uuid: userGuid || '',
                        client_id: biClientId || '',
                    }, onEmpty: _this.onEmpty, onError: _this.onEmpty }),
                withCloseButton && (React.createElement(BiLogger, { eventType: "click", eventData: {
                        evid: BiEventType.CLOSE_BANNER_AD,
                        realestateid: realEstateId,
                        campaignid: banner.bannerId,
                    } },
                    React.createElement(ButtonB5, { className: s['close-button'], icon: CloseIconBold, iconProps: { size: IconSize.MEDIUM }, onClick: function () { return _this.closeBanner(banner); } })))));
        };
        _this.closeBanner = function (bannerToClose) {
            var banners = _this.state.banners;
            _this.setState({
                banners: banners.filter(function (banner) { return banner['bannerId'] !== bannerToClose['bannerId']; }),
            });
        };
        _this.renderCarousel = function () {
            var goToNextInterval = _this.props.goToNextInterval;
            var banners = _this.state.banners;
            return (React.createElement(SwipeSlider, { goToNextInterval: goToNextInterval, indicatorsClassName: s['carousel-indicators'] }, banners.map(_this.renderBanner)));
        };
        _this.onEmpty = function () { return _this.setState({ isEmpty: true }); };
        return _this;
    }
    DealerAd.getDerivedStateFromProps = function (props) {
        var banners = props.banners;
        if (banners) {
            return {
                loaded: true,
                banners: banners,
            };
        }
        return null;
    };
    DealerAd.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, noAds = _a.noAds, banners = _a.banners;
        if (noAds) {
            return;
        }
        if (banners) {
            // banners are provided via props, no need to call API
            return;
        }
        axios
            .create( /* do not use wix axios config as it messes up CORS OPTIONS request for preflight */)
            .get('http://www.wix.com/_api/wix-dealer-webapp/da/offers', {
            headers: {},
            params: {
                realEstateId: this.props.realEstateId,
                userGuid: this.props.userGuid || '',
            },
        })
            .then(function (response) {
            _this.setState({
                loaded: true,
                banners: get(response, "data.dealerData[" + _this.props.realEstateId + "].offers"),
            });
        })
            .catch(this.onEmpty);
    };
    DealerAd.prototype.render = function () {
        var _a = this.props, className = _a.className, withCarousel = _a.withCarousel, noAds = _a.noAds;
        var _b = this.state, loaded = _b.loaded, banners = _b.banners, isEmpty = _b.isEmpty;
        if (noAds || isEmpty || (loaded && (!banners || !banners.length))) {
            return null; // collapse
        }
        return (React.createElement(ErrorBoundary, null,
            React.createElement("div", { className: classnames(s['root'], className) }, loaded &&
                (withCarousel
                    ? this.renderCarousel()
                    : this.renderBanner(banners[0])))));
    };
    return DealerAd;
}(React.Component));
export default DealerAd;
//# sourceMappingURL=DealerAd.js.map